// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"483":"e6c2e4def736fd25","888":"ae33295535d6d1d1"}[chunkId] + ".css";
};